import React, { Component } from 'react'
import moment from 'moment'
import { Trans } from 'react-i18next'
import formatter, {
  getCurrencySign,
  getFormattedCardPanShort
} from '../../../helpers/formatter'
import Icon from '../../../common/SimpleComponents/Icon'
import ReactTooltip from 'react-tooltip'
import numberFormat from '../../../helpers/numberFormat'

export const statusColors = {
  Rejected: {
    icon: 'icn-circle-close',
    view: '0 0 20 20',
    className: 'is-red'
  },
  Completed: {
    icon: 'icn-circle-tick',
    view: '0 0 17.5 17.5',
    className: 'is-green'
  },
  Pending: {
    icon: 'icn-circle-clock',
    view: '0 0 20 20',
    className: 'is-yellow'
  },
  BlockedTransaction: {
    icon: 'icn-circle-clock',
    view: '0 0 20 20',
    className: 'is-yellow'
  },
  WaitBankApproval: {
    icon: 'icn-circle-clock',
    view: '0 0 20 20',
    className: 'is-yellow'
  },
  SendBankApproval: {
    icon: 'icn-circle-clock',
    view: '0 0 20 20',
    className: 'is-yellow'
  },
  WaitAmlScan: {
    icon: 'icn-circle-clock',
    view: '0 0 20 20',
    className: 'is-yellow'
  },
  WaitAmlCheck: {
    icon: 'icn-circle-clock',
    view: '0 0 20 20',
    className: 'is-yellow'
  },
  WaitTranFilter: {
    icon: 'icn-circle-clock',
    view: '0 0 20 20',
    className: 'is-yellow'
  },
  SendTranFilter: {
    icon: 'icn-circle-clock',
    view: '0 0 20 20',
    className: 'is-yellow'
  },
  WaitFxApproval: {
    icon: 'icn-circle-clock',
    view: '0 0 20 20',
    className: 'is-yellow'
  },
  IsTemporary: {
    icon: 'icn-circle-clock',
    view: '0 0 20 20',
    className: 'is-yellow'
  },
  Canceled: {
    icon: 'icn-circle-close',
    view: '0 0 20 20',
    className: 'is-red'
  }
}

class CurrentTaskRow extends Component {
  constructor() {
    super()
    this.state = {
      hasOverflowingChildren: false
    }
    this.formatSenderIbn = this.formatSenderIbn.bind(this)
  }

  componentDidMount() {
    this.setState({
      hasOverflowingChildren:
        this.element.offsetHeight < this.element.scrollHeight ||
        this.element.offsetWidth < this.element.scrollWidth
    })
  }

  formatSenderIbn(senderIban) {
    switch (this.props.payType) {
      case 'P2PTransferByPan':
      case 'P2PTransfer': {
        return getFormattedCardPanShort(senderIban)
      }
      default:
        return formatter.getFormattedIBANInTransactionList(senderIban)
    }
  }

  render() {
    const {
      id,
      status,
      regDate,
      description,
      senderAmount,
      statusText,
      senderCurrency,
      senderIban,
      onClick,
      amountCurrency,
      receiverCurrency,
      receiverAmount,
      canceledKey
    } = this.props

    if (!statusColors[status]) console.log('status', status)

    return (
      <div className="lb-block-row block-pointer" onClick={onClick}>
        <ReactTooltip
          className="lb-tooltip type-darker"
          id={`div-status-${id}`}
          type="dark"
          effect="solid"
        >
          <span>
            {status !== 'Rejected' ? (
              <Trans i18nKey={`Common.${status}`} />
            ) : (
              statusText
            )}
          </span>
        </ReactTooltip>

        {this.state.hasOverflowingChildren && (
          <ReactTooltip
            className="lb-tooltip type-darker"
            id={`div-description-${id}`}
            type="dark"
            effect="solid"
          >
            <span>{description}</span>
          </ReactTooltip>
        )}
        <ReactTooltip
          className="lb-tooltip type-darker"
          id={`div-iban-${id}`}
          type="dark"
          effect="solid"
        >
          <span>{this.formatSenderIbn(senderIban)}</span>
        </ReactTooltip>

        <i
          className={`w-10 ${statusColors[status].icon +
            ' ' +
            statusColors[status].className}`}
        >
          <span
            id={`span-status-CurrentTaskRow-${id}`}
            data-tip
            data-for={`div-status-${id}`}
            className="tooltip-parent"
          >
            <Icon
              name={statusColors[status].icon}
              view={statusColors[status].view}
            />
          </span>
        </i>

        <div className="w-20 lb-ellipsis is-longdate fnt-14">
          {moment.unix(regDate).format('DD MMM YYYY')}
        </div>
        <div className="w-30 lb-ellipsis fnt-14 is-description">
          <span
            id={`span-description-CurrentTaskRow-${id}`}
            className="tooltip-parent-grid lb-ellipsis"
            data-tip
            data-for={`div-description-${id}`}
            ref={element => {
              this.element = element
            }}
          >
            {description}
          </span>
        </div>
        <div className="w-20 lb-ellipsis text-right is-reason">
          <span
            id={`span-iban-CurrentTaskRow-${id}`}
            className="tooltip-parent lb-ellipsis"
            data-tip
            data-for={`div-iban-${id}`}
          >
            {this.formatSenderIbn(senderIban)}
          </span>
        </div>
        <div className="w-20 lb-ellipsis-wrap flex text-right is-amount">
          <div className="lb-ellipsis">
            {numberFormat(
              amountCurrency && amountCurrency === receiverCurrency
                ? receiverAmount
                : senderAmount
            )}
          </div>
          <span className="ml-5">
            {' '}
            {getCurrencySign(amountCurrency || senderCurrency)}
          </span>
        </div>
        <i className="icn icn-arr-right">
          <Icon name="icn-arr-right" view="0 0 8.885 15.795" />
        </i>
      </div>
    )
  }
}

export default CurrentTaskRow
